import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from "react-i18next";
import 'intersection-observer';
import 'whatwg-fetch';

import i18n from "./i18n";
import App from './App';

import './styles/bootstrap-reboot.min.css';
import './styles/bootstrap-grid.min.css';
import './styles/slick.scss';
import './styles/slick-theme.scss';
import './index.scss';

// import * as serviceWorker from './serviceWorker';

ReactDOM.render(<I18nextProvider i18n={i18n}><App /></I18nextProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
